// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"1288":"e3a74eb4","7212":"cf85235f","9071":"5b34132c"}[chunkId] + ".css";
};